import { Link, useLocation } from 'react-router-dom'
import { ExternalLink, LogOut } from 'lucide-react'
import { useAuth } from '@/lib/auth-context'
import { NAV_ITEMS, resolveNavLabel, type NavItem } from './nav-items'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { Button } from '@/components/ui/button'

function pageTitleFor(pathname: string, role: 'admin' | 'seller'): string {
  const matchPath = (item: NavItem) => item.titlePath ?? item.path

  const exact = NAV_ITEMS.find((item) => pathname === matchPath(item))
  if (exact) return resolveNavLabel(exact, role)

  // Prefijo más largo (evita que "/admin" capture cualquier subruta antes que un match más específico).
  const prefixMatches = NAV_ITEMS.filter((item) => matchPath(item) !== '/admin' && pathname.startsWith(`${matchPath(item)}/`))
  const best = prefixMatches.sort((a, b) => matchPath(b).length - matchPath(a).length)[0]
  return best ? resolveNavLabel(best, role) : 'Panel'
}

export function Topbar() {
  const { auth, avatarUrl, logout } = useAuth()
  const location = useLocation()
  if (!auth) return null

  const initial = auth.user.name.trim().charAt(0).toUpperCase() || '?'

  return (
    <header className="sticky top-0 z-30 flex h-14 items-center gap-3 border-b bg-background/95 px-4 backdrop-blur-sm md:px-6">
      <h2 className="truncate font-heading text-sm font-semibold text-foreground">
        {pageTitleFor(location.pathname, auth.role)}
      </h2>

      <div className="ml-auto flex items-center gap-3">
        <a
          href="/"
          target="_blank"
          rel="noreferrer"
          className="hidden items-center gap-1 text-sm text-muted-foreground hover:text-foreground sm:flex"
        >
          Ver tienda
          <ExternalLink className="size-3.5" />
        </a>

        <Link to="/admin/configuracion" aria-label="Configuración">
          <Avatar size="sm">
            {avatarUrl && <AvatarImage src={avatarUrl} alt={auth.user.name} />}
            <AvatarFallback>{initial}</AvatarFallback>
          </Avatar>
        </Link>

        <Button variant="ghost" size="icon-sm" onClick={logout} aria-label="Cerrar sesión">
          <LogOut className="size-4" />
        </Button>
      </div>
    </header>
  )
}
